import React from 'react';
import StyledSlider from "../Slider/StyledSlider";
import {AdjustValue} from "./AdjustValue";
import { useTranslation } from 'react-i18next';

const SaunaActivity: React.FC<any> = ({
                                        temperature, setTemperature,
                                        humidity, setHumidity,
                                        time, setTime,
                                        adjustValue
                                      }) => {
  const { t } = useTranslation();

  const [temperatureInput, setTemperatureInput] = React.useState(temperature.toString());
  const [humidityInput, setHumidityInput] = React.useState(humidity.toString());
  const [timeInput, setTimeInput] = React.useState(time.toString());

  React.useEffect(() => {
    setTemperatureInput(temperature.toString());
  }, [temperature]);

  React.useEffect(() => {
    setHumidityInput(humidity.toString());
  }, [humidity]);

  React.useEffect(() => {
    setTimeInput(time.toString());
  }, [time]);

  return (
    <div>
      <h3>{t('bath_sauna_hammam')}</h3>
      <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
        <div>
          <div style={{display: 'flex', justifyContent:'space-between'}}>
            <label style={{display: 'flex', alignItems: 'center', gap: '0.5rem', padding: "20px 0 10px"}}>
              {t('air_temp')}:
              <input
                type="number"
                value={temperatureInput}
                onChange={(e) => setTemperatureInput(e.target.value)}
                onBlur={() => {
                  const parsed = Number(temperatureInput);
                  if (!isNaN(parsed)) {
                    const clamped = Math.min(Math.max(parsed, 40), 120);
                    setTemperature(clamped);
                  }
                }}
                step={1}
                style={{
                  width: '54px',
                  padding: '0.25rem 0 0.25rem 0.25rem',
                  fontSize: '20px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
              />
              °C
            </label>
            <AdjustValue adjust={adjustValue.bind(null,'temperature')}/>
          </div>
          <StyledSlider
            value={temperature}
            min={40}
            max={120}
            step={1}
            unit={'°C'}
            onChange={setTemperature}
          />
        </div>

        <div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>

            <label style={{display: 'flex', alignItems: 'center', gap: '0.5rem', padding: "20px 0 10px"}}>
              {t('air_humidity')}:
              <input
                type="number"
                value={humidityInput}
                onChange={(e) => setHumidityInput(e.target.value)}
                onBlur={() => {
                  const parsed = Number(humidityInput);
                  if (!isNaN(parsed)) {
                    const clamped = Math.min(Math.max(parsed, 20), 100);
                    setHumidity(clamped);
                  }
                }}
                step={1}
                style={{
                  width: '54px',
                  padding: '0.25rem 0 0.25rem 0.25rem',
                  fontSize: '20px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
              />
              %
            </label>
            <AdjustValue adjust={adjustValue.bind(null,'humidity')}/>
          </div>
          <StyledSlider
            value={humidity}
            min={20}
            max={100}
            step={1}
            unit={'%'}
            onChange={setHumidity}
            optimalRange={{from: 40, to: 80}}
          />
        </div>

        <div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>

            <label style={{display: 'flex', alignItems: 'center', gap: '0.5rem', padding: "20px 0 10px"}}>
              {t('duration')}:
              <input
                type="number"
                value={timeInput}
                onChange={(e) => setTimeInput(e.target.value)}
                onBlur={() => {
                  const parsed = Number(timeInput);
                  if (!isNaN(parsed)) {
                    const clamped = Math.min(Math.max(parsed, 1), 120);
                    setTime(clamped);
                  }
                }}
                step={1}
                style={{
                  width: '54px',
                  padding: '0.25rem 0 0.25rem 0.25rem',
                  fontSize: '20px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
              />
              {t('minutes')}
            </label>
            <AdjustValue adjust={adjustValue.bind(null,'time')}/>
          </div>
          <StyledSlider
            value={time}
            min={1}
            max={120}
            unit={t('minutes')}
            step={1}
            values={[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120]}
            onChange={setTime}
          />
        </div>
      </div>
    </div>
  );
};

export default SaunaActivity;